import React from 'react';
import PropTypes from 'prop-types';
import { BlockSelector, Select, OverlayTrigger, PopOver } from '@tencent/spaui';
import _ from 'lodash';
import { enumMessages, getMessage } from '@/utils/MessageUtils';

const reportHubDefaultKey = 'potential-status-select';

class PotentialStatusSelect extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    mode: PropTypes.oneOf(['select', 'block']).isRequired,
    disableCreateOrder: PropTypes.bool,
    onChange: PropTypes.func,
    onClear: PropTypes.func,
    usePotentialStatusNew: PropTypes.bool,
  }

  static defaultProps = {
    mode: 'select',
    usePotentialStatusNew: false, // block模式下，展示待处理选项，默认不展示
  }

  state = {
    potentialStatus: '',
    transactionProbability: '',
  }
  componentWillReceiveProps(nextProps) {
    const { potentialStatus, transactionProbability } = nextProps;

    if (potentialStatus === this.state.potentialStatus && transactionProbability === this.state.transactionProbability) {
      return false;
    }
  }
  render() {
    const { id, potentialStatus, transactionProbability, mode, disableCreateOrder, onClear, filterPontential, usePotentialStatusNew, multiple = false, PotentialStatusVal = [], reportHubKey } = this.props;
    let value = potentialStatus ? `${potentialStatus}-${transactionProbability}` : undefined;
    // multiple 支持多选
    if (multiple) {
      value = PotentialStatusVal;
    }
    const reportKey = reportHubKey || reportHubDefaultKey;

    let data = _.compact(_.map(enumMessages('MixedPotentialStatus'), (message) => {
      if (mode === 'block' && ((!usePotentialStatusNew && message.value === 'POTENTIAL_STATUS_NEW-0') || message.value === 'POTENTIAL_STATUS_NORMAL-100')) {
        return undefined;
      }
      if ((!mode || mode !== 'block') && message.value === 'POTENTIAL_STATUS_NORMAL-100') {
        return undefined;
      }
      return {
        value: message.value,
        label: message.message,
        'data-report': `${reportKey}-${message.value}`,
        popOver: getMessage(message.value, 'MixedPotentialStatus_PopOver'),
        disabled: disableCreateOrder && message.value === 'POTENTIAL_STATUS_NORMAL-100',
      };
    }));
    // 自定义data
    if (filterPontential) {
      data = _.filter(data, (v) => {
        return _.includes(filterPontential, v.value);
      });
    }
    if (mode === 'block') {
      return <BlockSelector
        id={id}
        data-report={reportKey}
        className="PotentialStatusSelect"
        data={data}
        value={value}
        onChange={this.handleChange}
        render={this.renderBlockItem}
      />;
    }
    return <Select
      id={id}
      data-report={reportKey}
      multiple={multiple}
      className="PotentialStatusSelect"
      data={data}
      value={value}
      search={false}
      clear={true}
      onChange={this.handleChange}
      onClear={onClear}
    />;
  }

  renderBlockItem = (value, data, attrs) => {
    const inner = (
      <div className="radio-block-txt">
        <p>
          <span>{data.label}</span>
        </p>
      </div>
    );
    if (data.popOver) {
      return (
        <OverlayTrigger trigger="hover" hideDelayTime={100} overlay={<PopOver>{data.popOver}</PopOver>}>
          {inner}
        </OverlayTrigger>
      );
    }
    return inner;
  }

  handleChange = (e, value) => {
    const { onChange, multiple } = this.props;
    if (multiple) {
      onChange(e, value);
      return;
    }
    if (value.indexOf('-') > -1) {
      this.setState({
        potentialStatus: value.split('-')[0],
        transactionProbability: parseInt(value.split('-')[1]),
      });
      onChange(e, {
        potentialStatus: value.split('-')[0],
        transactionProbability: parseInt(value.split('-')[1]),
      });
    } else {
      this.setState({
        potentialStatus: undefined,
        transactionProbability: undefined,
      });
      onChange(e, {
        potentialStatus: undefined,
        transactionProbability: undefined,
      });
    }
  }
}

export default PotentialStatusSelect;
